const LICENSE_PLATES = 'license-plates';

export const HOME_ROUTE = {
  title: 'Home',
  route: '',
};

export const NEWS_ROUTE = {
  title: 'News',
  route: 'news',
};

export const INFORMATION_ROUTE = {
  title: 'Information',
  route: 'info',
};

export const IDENTIFY_PLATES_ROUTE = {
  title: 'Identify Plates',
  route: `${INFORMATION_ROUTE.route}/identify-plates`,
};

export const ABBREVIATIONS_ROUTE = {
  title: 'Abbreviations',
  route: `${INFORMATION_ROUTE.route}/abbreviations`,
};

export const MOTORCYCLE_ROUTE = {
  title: 'Motorcycle',
  route: `${LICENSE_PLATES}/motorcycle`,
};

export const BICYCLE_ROUTE = {
  title: 'Bicycle',
  route: `${LICENSE_PLATES}/bicycle`,
};

export const BY_STATES_ROUTE = {
  title: 'By States',
  route: `${LICENSE_PLATES}/states`,
};

export const FRONTIER_ROUTE = {
  title: 'Frontier',
  route: `${LICENSE_PLATES}/frontier`,
};

export const BY_YEARS_ROUTE = {
  title: 'By Years',
  route: `${LICENSE_PLATES}/year-series`,
};

export const NATIONAL_ROUTE = {
  title: 'Federal',
  route: `${LICENSE_PLATES}/federal`,
};

export const METROPOLITAN_ROUTE = {
  title: 'Metropolitan',
  route: `${LICENSE_PLATES}/metropolitan`,
};

export const SEARCH_ROUTE = {
  title: 'Search',
  route: `${LICENSE_PLATES}/search`,
};

export const DONATIONS_ROUTE = {
  title: 'Donations',
  route: 'donations',
};

export const THANKS_ROUTE = {
  title: 'Thanks',
  route: 'thanks',
};

export const SHOP_PLATES_ROUTE = {
  title: 'Shop Plates',
  route: `${LICENSE_PLATES}/shop-plates`,
};

export const MISSING_PLATES_ROUTE = {
  title: 'Missing Plates',
  route: `${LICENSE_PLATES}/missing/1968-1997`,
};
